var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame45({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5016 17.1668H6.49803C2.49622 17.1668 1.1665 15.13 1.1665 13.0835V4.91683C1.1665 1.8519 2.49622 0.833496 6.49803 0.833496H14.5016C18.5035 0.833496 19.8332 1.8519 19.8332 4.91683V13.0835C19.8332 16.1484 18.4908 17.1668 14.5016 17.1668Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.208 14.3476L20.125 12.3036V5.68932L23.208 3.6453C24.7163 2.64949 25.9583 3.25746 25.9583 5.00798V12.9954C25.9583 14.7459 24.7163 15.3539 23.208 14.3476Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5835 7.8335C15.55 7.8335 16.3335 7.04999 16.3335 6.0835C16.3335 5.117 15.55 4.3335 14.5835 4.3335C13.617 4.3335 12.8335 5.117 12.8335 6.0835C12.8335 7.04999 13.617 7.8335 14.5835 7.8335Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame45);
export default __webpack_public_path__ + "static/media/Frame (45).08742721dd848ecdd5a23e87d1d2c600.svg";
export { ForwardRef as ReactComponent };